import { Flex, Text } from "@chakra-ui/react";
import { Layout } from "../../components/Layout/Layout";
import { SingleMainAnalyticBlock } from "../../components/AnalyticsBlocks/SingleMainAnalyticBlock";
import { useEffect } from "react";
import { useAppDispatch } from "../../store";
import { resetAnalyticsFilters } from "../../store/slices/analytics";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";


export const SingleAnalyticPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Сбрасываем фильтры при размонтировании компонента (выходе со страницы)
  useEffect(() => {
    return () => {
      dispatch(resetAnalyticsFilters());
    };
  }, [dispatch]);

  return (
    <Layout>
      <Flex flexDirection="column" overflow="none" maxH="90vh" overflowY="auto">
      <Text color="gray.500" cursor="pointer" onClick={() => navigate("/analytics?tab=1")} display="flex" alignItems="center" gap="8px">
            <ArrowBackIcon />
            Назад к аналитике
          </Text>
        <Text fontSize="27px" fontWeight={500} color="#050505">
          Аналитика
        </Text>
        <Flex paddingTop="16px" w="100%">
          <SingleMainAnalyticBlock />
        </Flex>
      </Flex>
    </Layout>
  );
};